<div class="partner-signup-modal">
  @if (loaded) {
    <div class="partner-header">
      <img
        [src]="customFlowSmallImage"
        class="partner-logo"
        [alt]="customFlowName" />
      <div class="partner-info">
        <tidy-text [body]="customFlowName" />
        <span>&nbsp;</span>
        <tidy-text [body]="'offers a'" />
        <span>&nbsp;</span>
        <tidy-text [body]="customFlowDiscount" />
        <span>&nbsp;</span>
        <tidy-text [body]="'% discount on all cleanings.'" />
      </div>
    </div>

    <div class="login-section">
      <tidy-text [body]="'Already have an account?'" />
      <span>&nbsp;</span>
      <tidy-text
        [body]="'Log In'"
        class="link"
        (action)="goToLoginPage()" />
    </div>

    <div class="divider-section">
      <tidy-text [helper]="'or'" class="divider" />
    </div>

    <div class="prompt-section">
      <tidy-text [body]="'Enter the address for instant pricing & availability for cleanings in your area.'" />
    </div>

    <tidy-card>
      <form [formGroup]="form" novalidate action="#">
        <tidy-row class="field-top-padding">
          <tidy-input-international-phone
            formControlName="phone"
            [label]="'Phone'"
            [form]="form.controls.phone"
            [inputMode]="'numeric'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid phone.'"
            [icon]="'assets/svg/phone-portrait.svg'"
            [initialMask]="{ mask: '[00000000000000000000000]' }"
            (countryCodeChange)="onCountryCodeChange($event)" />
        </tidy-row>
        <tidy-row>
          <tidy-select
            [icon]="'assets/svg/location.svg'"
            [label]="'Country'"
            [items]="countryList"
            [form]="form.get('countryCode')"
            formControlName="countryCode"
            (optionChange)="changeCountrySelected($event)" />
        </tidy-row>
        <tidy-row>
          <tidy-auto-complete
            label="Address"
            formControlName="address"
            [options]="autocompleteAddress"
            [icon]="'assets/svg/home.svg'"
            [form]="form.controls.address"
            [errorMessage]="'Please enter a valid address'"
            [submitted]="submitted"
            (keyup)="updateSearch()"
            (action)="chooseItem($event)" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            formControlName="address2"
            [form]="form.controls.address2"
            label="Unit / Apartment"
            [errorMessage]="'Please enter a valid unit'"
            [submitted]="submitted"
            [icon]="'assets/img/door.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            formControlName="zipcode"
            [customMask]="zipCodeMask"
            [form]="form.controls.zipcode"
            [errorMessage]="'Please enter a valid zipcode'"
            [submitted]="submitted"
            [inputMode]="'numeric'"
            label="Postal Code"
            [icon]="'assets/img/mailbox.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            formControlName="addressNickname"
            [form]="form.controls.addressNickname"
            [label]="'Property Nickname (optional)'"
            [icon]="'assets/svg/information-circle.svg'" />
        </tidy-row>
      </form>
    </tidy-card>

    @if (radioButtonAddress.length > 0 && submitted && !didChooseAddress) {
      <tidy-card>
        <form [formGroup]="form" novalidate action="#">
          <tidy-row>
            <tidy-text [header]="'Please confirm your address:'" />
          </tidy-row>
          <tidy-row>
            <tidy-radio-button
              [helper]="'If you do not see your address please retype it above'"
              [items]="radioButtonAddress"
              (optionChange)="confirmAndSubmitAddress($event)" />
          </tidy-row>
        </form>
      </tidy-card>
    }

    <tidy-error-message [text]="errorMessage" />

    @if (isLoading) {
      <div class="loading-section">
        <ion-spinner name="lines" />
      </div>
    } @else {
      <tidy-button
        [text]="'Add Property'"
        class="primary"
        [action]="addAddress" />
    }
  } @else {
    <div class="loading-section">
      <ion-spinner name="lines" />
    </div>
  }
</div>
